/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LocalReplyListContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_settings">;
    readonly " $refType": "LocalReplyListContainer_settings";
};
export type LocalReplyListContainer_settings$data = LocalReplyListContainer_settings;
export type LocalReplyListContainer_settings$key = {
    readonly " $data"?: LocalReplyListContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LocalReplyListContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '1c92416cfb366134300a94ed30995b1d';
export default node;
